/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import Footer from '../components/Footer';
import IntroduceTopMenu from '../components/IntroduceTopMenu';
import Slider from 'react-slick';
import * as Consts from '../components/Consts';

import support_02 from '../images/Content/support_2_목표일지정알림.JPG';
import balance_01 from '../images/Content/balance_1_백색소음기.jpg';
import balance_02 from '../images/Content/balance_2_산소발생기.jpg';
import balance_03 from '../images/Content/balance_3_조명과인테리어.JPG';
import balance_04 from '../images/Content/balance_4_온도유지.JPG';
import balance_05 from '../images/Content/balance_5_15가지음료.jpg';
import balance_06 from '../images/Content/balance_6_수면케어.JPG';
import safe_01 from '../images/Content/safe_1_알림톡입퇴실.JPG';
import safe_02 from '../images/Content/safe_2_지문인식.JPG';
import community_01 from '../images/Content/community_1.jpg';

const _typeMap = {
  'support': [
    {
      title: '목표일 지정 알림 서비스',
      desc: '입실체크 시 출입을 위한 모니터에 목표와 D-day를 알려드립니다.',
      img: support_02
    }
  ],
  'balance': [
    {
      title: '집중력 향상 서비스',
      desc: '백색소음기는 집중에 도움을 줍니다.',
      img: balance_01
    }, {
      title: '집중력 향상 서비스',
      desc: '산소발생기는 맑은 산소를 제공하여 쾌적한 환경을 제공합니다.',
      img: balance_02
    }, {
      title: '집중력 향상 서비스',
      desc: '설치된 조명과 인테리어는 학습자의 눈의 피로도를 최소화 합니다.',
      img: balance_03
    }, {
      title: '집중력 향상 서비스',
      desc: '온도유지시스템을 통해 학습자의 신체 밸런스를 유지합니다.',
      img: balance_04
    }, {
      title: '집중력 향상 서비스',
      desc: '15가지의 다양한 음료를 통해 학습자의 신체 밸런스를 유지합니다.',
      img: balance_05
    }, {
      title: '수면 관리 서비스',
      desc: '지점 매니저가 책상을 톡톡 두드려 깨워주는 서비스 입니다.',
      img: balance_06
    }
  ],
  'safe': [
    {
      title: '입퇴실/문자발송 서비스',
      desc: '학부모님들의 자녀 걱정은 이제 그만, 자녀분의 입/퇴실 시 학부모님께 문자를 발송해드리는 서비스 입니다.',
      img: safe_01
    }, {
      title: '지문인식 보안 서비스',
      desc: '지문인식을 통한 출입 기능으로 안심하고 공부에 전념할 수 있는 서비스 입니다.',
      img: safe_02
    }
  ],
  'community': [
    {
      title: '그룹 룸 서비스',
      desc: '그룹학습을 위한 미팅룸 이용 서비스 입니다.',
      img: community_01
    }
  ],
}

class Introduce02 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: 'support',
      typeMap: _typeMap['support'],
      slideIdx: 0
    };
  }

  componentDidMount() {
  }

  /**
   * 탭 변경 event
   */
  _doChangeType = (type, e) => {
    // 이미지 슬라이드가 다른 페이지면 맨 앞으로 이동
    this.slider.slickGoTo(0);
    
    this.setState({
      type: type,
      typeMap: _typeMap[type],
      slideIdx: 0
    });
  }

  render() {
    return (
      <div>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap" className="div-cont" >
              <div id="contents">
                <div className="app-header">
                  <p className="app-logo" onClick={() => {window.location.href = '/'}}><span className="blind">TOZ StudyCenter</span></p>
                  <a href="/introduce" className="app-close"><span className="blind">닫기</span></a>
                </div>

                <div className="info-cont">

                  <IntroduceTopMenu link={this.props.location.pathname} />

                  <div className="info-vis img02">
                    <p className="stxt">학습효율을 높이기 위한</p>
                    <p className="btxt">11가지 전문적인<br/><strong>관리서비스</strong>를 시작하다.</p>
                    <p className="ctxt">Since 2010</p>
                  </div>
                  
                  <div className="info-slide-cont">
                    <Slider {...Consts.SLIDE_INTRODUCE_SETTINGS} className="info-slide-tap">
                      <div className={this.state.type === 'support' ? 'active' : ''}><a href={null} onClick={this._doChangeType.bind(this, 'support')}>SUPPORT</a></div>
                      <div className={this.state.type === 'balance' ? 'active' : ''}><a href={null} onClick={this._doChangeType.bind(this, 'balance')}>BALANCE</a></div>
                      <div className={this.state.type === 'safe' ? 'active' : ''}><a href={null} onClick={this._doChangeType.bind(this, 'safe')}>SAFE</a></div>
                      <div className={this.state.type === 'community' ? 'active' : ''}><a href={null} onClick={this._doChangeType.bind(this, 'community')}>COMMUNITY</a></div>
                    </Slider>
                    
                    <p className="btxt">{this.state.type ? _typeMap[this.state.type][this.state.slideIdx].title : ''}</p>
                    <p className="stxt">{this.state.type ? _typeMap[this.state.type][this.state.slideIdx].desc : ''}</p>

                    <Slider ref={ref => (this.slider = ref)} dots={true} beforeChange={(current, next) => this.setState({ slideIdx: next })} {...Consts.SLIDE_INTRODUCE_SETTINGS} className="info-slide">
                      {this.state.type ? this.state.typeMap.map((entity, index) => <div key={index}><img src={entity.img} alt={this.state.type + index} /></div>) : ''}
                    </Slider>
                  </div>
                </div>

                <Footer />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Introduce02;